<template>
  <div>
    <header-top />
    <div
      ref="wrapper"
      class="wrapper"
    >
      <c-aside
        class="aside"
        @changeStatus="isOpen=!isOpen"
      />
      <div
        ref="content"
        class="body-content"
      >
        <router-view />
      </div>
    </div>
    <div
      v-if="updating"
      class="update_box"
    >
      <div>
        <img src="../../assets/img/msg.png">
        <p class="p1">知药系统正在升级，稍后请刷新…</p>
        <p class="p2">给你带来的不便，敬请谅解</p>
      </div>
    </div>
  </div>
</template>

<script>
  import Aside from '@/components/aside/aside';
  import headerTop from '@/components/header/header';

  export default {
    name: 'lay-out',
    componentName: 'layOut',
    components: {
      'CAside': Aside,
      'headerTop': headerTop
    },
    data() {
      return {
        isOpen: false,
        updating: false,
        time: '',
      };
    },
    computed: {
      userList() {
        return this.$store.state.userLimit;
      }
    },
    mounted() {
      this.$on('isAsideOpen', (v) => {
        this.setTableHeight();
      });
      window.addEventListener('resize', () => {
        this.setTableHeight();
      });
    },
    methods: {
      setTableHeight() {
        if (this.time) {
          return;
        }
        this.$children.forEach((child) => {
          if (child.$options && child.$options.componentName == 'tableHeight') {
            this.time = setTimeout(() => {
              child.handleSearchFormChange();
              this.time = '';
              clearTimeout(this.time);
            }, 800);
          }
        });
      }
    },
  };

</script>

<style lang="scss" scoped>
  .wrapper {
    position: relative;
    display: flex;
    height: calc(100vh - 60px);
    overflow: hidden;
  }

  .aside {
    height: 100%;
  }

  .body-content {
    background: #f2f5f7;
    height: calc(100vh - 60px);
    flex: 1;
    padding: 10px;
    overflow-y: auto;
  }

  .update_box {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.3);

    div {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      text-align: center;
      width: 568px;
      height: 360px;
      border-radius: 6px;
      padding-top: 60px;
      background: #fff;

      img {
        width: 158px;
        height: 158px;
        margin-bottom: 40px;
      }

      .p1 {
        font-size: 18px;
        line-height: 28px;
        color: #333;
        margin-bottom: 10px;
      }

      .p2 {
        font-size: 12px;
        color: #666;
        line-height: 22px;
      }
    }
  }
</style>
<style lang="scss">
  #edui1_iframeholder {
    height: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/index.vue